import React, { useMemo } from "react";
import { Table, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "./Scoreboard.css";
import { useHistory, useParams, useLocation } from "react-router-dom";
import SideNav from "../../Sidenav";
import DemographicsPatientDetail from "../DemographicsPatientDetail";
import { useSelector, useDispatch } from "react-redux";
import { GetSideNav } from "../../../StateManagement/Reducers/ScheduleState";
import { useEffect, useState } from "react";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { downloadScoreboardPDF } from "./ScoreboardPDFReport";
import { Modal } from "react-bootstrap";
import TemplateWorkAreas from "../../setting/Templates/TemplateWorkAreas";
import { BsCheckCircle } from "react-icons/bs";
import { ArrowLeftOutlined } from "@ant-design/icons";
const getDefaultColors = (count) => {
  if (count === 3) {
    return ["#27AE60", "#F2C94C", "#EB5757"];
    // Green, Yellow, Red
  }

  if (count === 4) {
    return ["#56CCF2", "#27AE60", "#F2994A", "#EB5757"];
    // SkyBlue, Green, Orange, Red
  }

  if (count === 5) {
    return ["#56CCF2", "#27AE60", "#F2C94C", "#F2994A", "#EB5757"];
    // SkyBlue, Green, Yellow, Orange, Red
  }

  // fallback for any other count
  const base = ["#56CCF2", "#27AE60", "#F2C94C", "#F2994A", "#EB5757"];
  return base.slice(0, count);
};

const Scoreboard = () => {
  const history = useHistory();
  const { pid, sid } = useParams();
  const patientId = pid;
  const screeningFormId = sid;

  const [facilityInfo, setFacilityInfo] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ShowAddForms, setShowAddForms] = useState(false);
  const [AlertsMsg, setAlertMsg] = useState("");
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [content, setcontent] = useState("");
  const [EditDocName, setEditDocName] = useState("");
  const [rows, setfutureId] = useState([]);
  const [id, setid] = useState();

  var provider = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  useEffect(() => {
    axiosInstance
      .get("/vozonew/patient?pid=" + patientId)
      .then((response) => {
        let DecodeVal = Decrypt_Value(response.data, "vozo");
        setfutureId([DecodeVal]);
      })
      .catch(() => {
        setfutureId([]);
      });
  }, [patientId]);

  useEffect(() => {
    axiosInstance
      .get("/vozo/setting/facility")
      .then((response) => {
        const decoded = Decrypt_Value(response.data, "vozo");

        if (Array.isArray(decoded) && decoded.length > 0) {
          setFacilityInfo(decoded[0]);
        }
      })
      .catch((error) => {
        console.error("Facility fetch error:", error);
        setFacilityInfo(null);
      });
  }, []);

  useEffect(() => {
    fetchSingleScore();
  }, [patientId, screeningFormId]);

  const fetchSingleScore = async () => {
    if (!patientId || !screeningFormId) return;

    try {
      const payload = { screening_form_id: screeningFormId };
      const encrypted = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        `/vozo/scoremeasure?pid=${patientId}`,
        encrypted,
      );

      const decrypted = Decrypt_Value(response.data, "vozo");
      setRowData(decrypted || null);
    } catch (error) {
      console.error("Scoreboard API error:", error);
      setRowData(null);
    }
  };

  const handleDownloadPDF = () => {
    if (!rowData) return;
    downloadScoreboardPDF(rowData, rows[0], facilityInfo);
  };

  const goToTreatmentPlan = () => {
    history.push(`/patient/treatmentplan/${patientId}`);
  };

  const goToMedication = () => {
    history.push(`/patient/medication/${patientId}`);
  };

  /* ================= TOTAL SCORE ================= */
  const dispatch = useDispatch();
  const [navData1, setNavData1] = useState("iconclose");

  const NavData1 = useSelector((state) => state.Schedule?.NavData);

  useEffect(() => {
    dispatch(GetSideNav("demographics"));
  }, []);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  const location = useLocation();

  const currentScore = useMemo(() => {
    return (
      rowData?.Assessment_values?.reduce(
        (sum, item) => sum + (item?.score || 0),
        0,
      ) || 0
    );
  }, [rowData]);

  //   const scoringData = rowData?.Assessment_question?.map((q, index) => {
  //   const selected = rowData?.Assessment_values?.find(
  //     v => v.question_id === q.question_id
  //   );

  //   const selectedOption = rowData?.Assessment_options?.find(
  //     o => o.option_id === selected?.selected_option_id
  //   );

  //   return {
  //     key: index,
  //     sno: index + 1,
  //     question: q.question,
  //     response: selectedOption?.option || "-",
  //     score: selected ? `${selected.score}/3` : "- / 3"
  //   };
  // }) || [];
  const scoringData =
    rowData?.Assessment_question?.map((q, index) => {
      const selected = rowData?.Assessment_values?.find(
        (v) => v.question_id === q.question_id,
      );

      const optionsForQuestion =
        rowData?.Assessment_options?.filter(
          (o) => o.question_id === q.question_id,
        ) || [];

      // Highest score for this question
      const maxScoreForQuestion = optionsForQuestion.length
        ? Math.max(...optionsForQuestion.map((o) => o.score || 0))
        : 0;

      const selectedOption = optionsForQuestion.find(
        (o) => o.option_id === selected?.selected_option_id,
      );

      return {
        key: index,
        sno: index + 1,
        question: q.question,
        response: selectedOption?.option || "-",
        score: selected
          ? `${selected.score}/${maxScoreForQuestion}`
          : `- / ${maxScoreForQuestion}`,
      };
    }) || [];

  const columns = [
    { title: "S.No", dataIndex: "sno", width: "8%" },
    { title: "Questions", dataIndex: "question", width: "42%" },
    { title: "Response", dataIndex: "response", width: "35%" },
    { title: "Score", dataIndex: "score", width: "15%" },
  ];
  const dynamicGuide = useMemo(() => {
    const guide = rowData?.scoring_guide || [];
    const colors = getDefaultColors(guide.length);

    return guide.map((item, index) => ({
      min: item.min,
      max: item.max,
      severity: item.label,
      score: `${item.min}-${item.max}`,
      color: colors[index] || "#999",
    }));
  }, [rowData]);
  const maxScore = dynamicGuide.length
    ? Math.max(...dynamicGuide.map((g) => g.max))
    : 10;

  // const severityLevel =
  //   dynamicGuide.find(g => currentScore >= g.min && currentScore <= g.max) ||
  //   dynamicGuide[0];
  const severityLevel = useMemo(() => {
    if (!dynamicGuide.length) return null;

    // Try normal range match
    const matched = dynamicGuide.find(
      (g) => currentScore >= g.min && currentScore <= g.max,
    );

    if (matched) return matched;

    // If score is greater than last max → return last range
    const lastRange = dynamicGuide[dynamicGuide.length - 1];

    if (currentScore > lastRange.max) {
      return lastRange;
    }

    // If score is lower than first min → return first range
    if (currentScore < dynamicGuide[0].min) {
      return dynamicGuide[0];
    }

    return null;
  }, [currentScore, dynamicGuide]);

  // const activeIndex = dynamicGuide.findIndex(
  //   g => currentScore >= g.min && currentScore <= g.max
  // );
  const activeIndex = useMemo(() => {
    if (!dynamicGuide.length) return -1;

    const index = dynamicGuide.findIndex(
      (g) => currentScore >= g.min && currentScore <= g.max,
    );

    if (index !== -1) return index;

    // If score exceeds → highlight last segment
    if (currentScore > dynamicGuide[dynamicGuide.length - 1].max) {
      return dynamicGuide.length - 1;
    }

    // If below first → highlight first
    if (currentScore < dynamicGuide[0].min) {
      return 0;
    }

    return -1;
  }, [currentScore, dynamicGuide]);

  const showAlert = severityLevel?.severity?.toLowerCase().includes("severe");
  /* ================= GAUGE ================= */

  const radius = 80;
  const strokeWidth = 12;
  const center = 100;

  const polarToCartesian = (cx, cy, r, angle) => {
    const rad = (angle - 180) * (Math.PI / 180);
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  };

  const describeArc = (startAngle, endAngle, color) => {
    const start = polarToCartesian(center, center, radius, endAngle);
    const end = polarToCartesian(center, center, radius, startAngle);
    return (
      <path
        d={`M ${start.x} ${start.y} A ${radius} ${radius} 0 0 0 ${end.x} ${end.y}`}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
    );
  };

  const TOTAL_ARC = 180;
  const SEGMENT_COUNT = dynamicGuide.length;
  const GAP = 14;

  const segmentAngle = (TOTAL_ARC - GAP * (SEGMENT_COUNT - 1)) / SEGMENT_COUNT;

  const segments = dynamicGuide.map((item, i) => {
    const start = i * (segmentAngle + GAP);
    const end = start + segmentAngle;

    return {
      start,
      end,
      color: item.color,
    };
  });
  const handleBack = () => {
    if (location.state?.returnPath) {
      history.push(location.state.returnPath);
    } else {
      history.goBack();
    }
  };

  const handleShowAdd = (portalId) => {
    setid(portalId);

    setEditDocName("");
    setcontent("");

    setShowAddForms(true);
  };
  const closeAddForms = () => {
    setShowAddForms(false);
    setEditDocName("");
    setcontent("");
  };

  const handleShowEdit = (portalId, note_file_url, form_name) => {
    if (!note_file_url) return;

    setid(portalId);

    const article = { path: note_file_url };
    let encrypted = Encrypt_Value(article, "vozo");

    axiosInstance
      .put("/vozo/patient/get/Document/one", encrypted)
      .then((response) => {
        let data = Decrypt_Value(response.data, "vozo");

        if (data) {
          setcontent(data);
          setEditDocName(form_name);
          setShowAddForms(true);
        } else {
          console.log("No content returned");
        }
      })
      .catch((err) => {
        console.error("Edit fetch error:", err);
      });
  };

  const savedocument = (
    temp,
    name,
    category,
    speciality,
    fortype,
    isAutoSave,
    SupType,
    provid,
    isSupervisor,
  ) => {
    const selected = rowData;

    if (!selected?.file_url) {
      var article = {
        temp: temp,
        path: "",
        pid: patientId,
        editdocname: name,
        uid: provider,
        category: category,
        speciality: speciality,
        type: "Dashboard",
      };

      let encrypted = Encrypt_Value(article, "vozo");

      axiosInstance
        .post(`/vozo/score/insertdocumenttemplatescore?id=` + id, encrypted)
        .then(() => {
          if (!isAutoSave) {
            setAlertMsg("Notes Saved successfully");
            setModalAlerShow(true);

            fetchSingleScore();

            setTimeout(() => setModalAlerShow(false), 1500);
            setShowAddForms(false);
          }
        });
    } else {
      var article = {
        temp: temp,
        path: selected.file_url,
        editdocname: name,
        conformid: id,
        category: category,
        speciality: speciality,
        uid: provider,
        type: " ",
      };

      let encrypted = Encrypt_Value(article, "vozo");

      axiosInstance
        .post("/vozo/updatedocument_template/data", encrypted)
        .then(() => {
          if (!isAutoSave) {
            setAlertMsg("Notes Saved successfully");
            setModalAlerShow(true);

            fetchSingleScore();

            setTimeout(() => setModalAlerShow(false), 1500);
            setShowAddForms(false);
          }
        });
    }
  };
  /* ================= UI ================= */
  return (
    <>
      <SideNav />

      <div
        className={
          navData1 === "iconopen"
            ? "nav_right  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
            : "nav_right1  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
        }
      >
        <div className="d-flex">
          <DemographicsPatientDetail />

          <div className="imm-main-block m-t-0 m-b-15 w-82-5">
            <div className="scoreboard-container">
              <div className="scoreboard-header">
                <h2 className="scoreboard-title">Scoreboard</h2>

                <div className="scoreboard-buttons">
                  <Button
                    type={!rowData?.file_url ? "primary" : "default"}
                    className={`sb-btn ${!rowData?.file_url ? "sb-btn-primary" : "sb-btn-edit"
                      }`}
                    onClick={() =>
                      !rowData?.file_url
                        ? handleShowAdd(rowData.portalid)
                        : handleShowEdit(
                          rowData.portalid,
                          rowData.file_url,
                          rowData.form_name,
                        )
                    }
                  >
                    {!rowData?.file_url ? "+ Add Notes" : "Edit Notes"}
                  </Button>
                  <Button
                    className="sb-btn sb-btn-secondary"
                    onClick={goToTreatmentPlan}
                  >
                    Treatment Plan
                  </Button>

                  <Button
                    className="sb-btn sb-btn-secondary"
                    onClick={goToMedication}
                  >
                    Medication
                  </Button>

                  <Button
                    icon={<DownloadOutlined />}
                    className="sb-btn sb-btn-icon"
                    onClick={handleDownloadPDF}
                  />
                </div>
              </div>
              <div style={{ textAlign: "left", marginLeft: "10px" }}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBack}
                  className="sb-back-arrow"
                />
              </div>

              <div className="scoreboard-content-box">
                <div className="scoreboard-flex-row">
                  <div className="gauge-section">
                    <h4 className="gauge-label-top">Score</h4>

                    <div className="gauge-wrapper">
                      <svg width="400" height="200" viewBox="0 0 200 120">
                        {segments.map((seg, i) => {
                          const strokeColor =
                            i <= activeIndex ? seg.color : "#E0E0E0";
                          return (
                            <React.Fragment key={i}>
                              {describeArc(seg.start, seg.end, strokeColor)}
                            </React.Fragment>
                          );
                        })}
                        {Array.from({ length: maxScore + 1 }).map((_, i) => {
                          const angle = 5 + ((175 - 5) / maxScore) * i;
                          const tickRadius = radius - 18;
                          const { x, y } = polarToCartesian(
                            center,
                            center,
                            tickRadius,
                            angle,
                          );

                          return (
                            <circle
                              key={i}
                              cx={x}
                              cy={y}
                              r="1"
                              fill="#BDBDBD"
                            />
                          );
                        })}

                        <text
                          x="14"
                          y="118"
                          fontSize="10"
                          fill="#888"
                          textAnchor="middle"
                        >
                          0
                        </text>
                        <text
                          x="186"
                          y="118"
                          fontSize="10"
                          fill="#888"
                          textAnchor="middle"
                        >
                          {maxScore}
                        </text>
                      </svg>

                      <div className="gauge-value-display">
                        <div className="gv-number">{currentScore}</div>
                        <div className="gv-text">{severityLevel?.severity}</div>
                      </div>
                    </div>
                  </div>

                  <div className="info-section">
                    {severityLevel?.severity
                      ?.toLowerCase()
                      .includes("severe") && (
                        <div className="alert-box">
                          {" "}
                          <div className="alert-row">
                            {" "}
                            <div className="alert-icon-wrapper">
                              {" "}
                              <span className="alert-icon">!</span>{" "}
                            </div>{" "}
                            <div className="alert-content">
                              {" "}
                              <div className="alert-title">
                                {" "}
                                Critical Alert - High Risk Assessment Score{" "}
                              </div>{" "}
                              <div className="alert-description">
                                {" "}
                                This patient's assessment result indicates a
                                high-risk condition that requires immediate
                                clinical attention{" "}
                              </div>{" "}
                            </div>{" "}
                          </div>{" "}
                        </div>
                      )}
                    <div className="gad-guide">
                      <div className="gad-title">
                        {rowData?.screen_form_name
                          ? `${rowData.screen_form_name} Scoring Guide`
                          : "Scoring Guide"}
                      </div>
                      <div className="gad-table">
                        <div className="gad-header">
                          <div className="gad-col-1">Score</div>
                          <div className="gad-col-2">Anxiety Severity</div>
                        </div>{" "}
                        {dynamicGuide.map((item, idx) => (
                          <div key={idx} className="gad-row">
                            <div className="gad-col-1">
                              <span
                                className="gad-dot"
                                style={{ backgroundColor: item.color }}
                              />
                              <span>{item.score}</span>
                            </div>
                            <div className="gad-col-2">{item.severity}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="questions-table">
                  <Table
                    columns={columns}
                    dataSource={scoringData}
                    pagination={false}
                    bordered={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="client-popup-for-billing-profiles popup_centre"
        centered
        show={ShowAddForms}
        onHide={() => {
          setShowAddForms(false);
          setEditDocName("");
          setcontent("");
        }}
      >
        <Modal.Body
          className="ed-doc-mod-body"
          id="cnst_frm-mod_bdy"
          style={{ padding: 0 }}
        >
          {rows.length > 0 && (
            <TemplateWorkAreas
              closeTemplate={() => {
                setShowAddForms(false);
                setEditDocName("");
                setcontent("");
              }}
              savetemplate={savedocument}
              EditDocName={EditDocName}
              content={content}
              patientdetails={rows[0]}
              fromTemplate="Dashboard"
              eid=""
              portalid={id}
              onHide={closeAddForms}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal className="alert-popup-message" show={ModalAlerShow}>
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" /> {AlertsMsg}
        </div>
      </Modal>
    </>
  );
};
export default Scoreboard;
